// extracted by mini-css-extract-plugin
export default {"banner":"trainingBanner_banner__M0pFq","overlay":"trainingBanner_overlay__Oiv2I","title":"trainingBanner_title__Wrphh"};